import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "profile cart"
}
const _hoisted_2 = { class: "card profile-info full-height" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_5 = { class: "basket-title mb-0" }
const _hoisted_6 = { class: "basket-title-count" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "available-for-order-banner mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { translate: "yes" }, "Доступны для заказа")
], -1)
const _hoisted_8 = { class: "cart__content row d-flex flex-md-row flex-column mt-4" }
const _hoisted_9 = { class: "cart__products col-md-8" }
const _hoisted_10 = { class: "cart__payment ms-auto col-lg-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "border-button mt-4 w-100",
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#buyModal"
}, " Перейти к оформлению ", -1)
const _hoisted_12 = {
  key: 1,
  class: "notInfo"
}

import { ref, onMounted, computed } from 'vue';
  import ProductCard from '@/components/Profile/ProductCard.vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import type { Cart } from '@/services/marketplace';
  import BuyModal from '@/components/Modals/BuyModal.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Basket',
  setup(__props) {

  const store = useStore();
  const router = useRouter();

  const loggedIn = computed(() => store.state.auth.status.loggedIn);
  const cartCount = computed(() => store.state.user.cartItems);

  const selectAll = ref(false);
  const selectedProducts = ref<number[]>([]);
  const cart = ref<Cart | null>(null);

  const reloadCart = () => {
    store.dispatch('user/getCartItems').then((updatedCart: Cart) => {
      cart.value = updatedCart;
    });
  };

  const updateSelectedProducts = (updatedSelection: number[]) => {
    selectedProducts.value = updatedSelection;
    updateSelectAllState();
  };

  const updateSelectAllState = () => {
    selectAll.value = cart.value?.baskets.every((item) => selectedProducts.value.includes(item.product.id)) || false;
  };

  const totalSum = computed(() => {
    if (!cart.value || !cart.value.baskets) return 0;

    return cart.value.baskets.reduce((total, item) => {
      // Берем цену со скидкой, если она > 0, иначе обычную
      const price =
        item.product.sale_price && Number(item.product.sale_price) > 0
          ? Number(item.product.sale_price)
          : Number(item.product.price);

      return total + price * item.quantity;
    }, 0);
  });

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  onMounted(() => {
    if (!loggedIn.value) {
      router.push('/');
    } else {
      reloadCart();
    }
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (cart.value?.baskets?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, [
                  _createTextVNode(" Корзина"),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(cartCount.value), 1)
                ])
              ]),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cart.value.baskets, (item) => {
                    return (_openBlock(), _createBlock(ProductCard, {
                      id: item.id,
                      key: item.id,
                      product: item.product,
                      quantity: item.quantity,
                      "reload-cart": reloadCart,
                      "selected-products": selectedProducts.value,
                      "onUpdate:selectedProducts": updateSelectedProducts
                    }, null, 8, ["id", "product", "quantity", "selected-products"]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h2", null, "Итого " + _toDisplayString(formatPrice(totalSum.value)), 1),
                  _hoisted_11
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, "Товаров не найдено")),
    _createVNode(BuyModal)
  ], 64))
}
}

})